<template>
  <modal-layout>
    <div class="inter-modal-header">
      <h1 class="inter-modal-title">{{ data.type }}</h1>
      <p class="inter-modal-desc">{{ data.title }}</p>
    </div>

    <div class="inter-modal-content">
      <div class="inter-modal-choice" v-for="(c, index) in data.choices" :class="c.selected ? 'selected' : ''" :key="c.id"
        tabindex="0" @keyup.enter="handleClickChoice(index)" @click="handleClickChoice(index)">
        {{ c.choice }}
      </div>
    </div>
    <div class="inter-modal-footer">
      <button class="inter-modal-btn" @click="closeInteractivityModal">
        {{ $t('buttons.ignore') }}
      </button>

      <button class="inter-modal-btn" @click="handleSubmit">
        {{ $t('buttons.valid') }} &rarr;
      </button>
    </div>
  </modal-layout>
</template>

<script >
import cookies from "@/components/utils/cookies";
import { defineComponent } from "vue";
import ModalLayout from "../ModalLayout.vue";
import RichMediaServices from "../../../../services/RichMediaServices/RichMediaServices";
import { durationToSeconds } from "../../../../components/utils/helpers";
import en from '../../../../i18n/en_US'
import fr from '../../../../i18n/fr_FR'
import { mapGetters } from "vuex";

export default defineComponent({
  name: "inter-sondage",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {
    ModalLayout,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
    closeModal: {
      required: true,
      type: Function,
    },
    player: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      choices: [],
    };
  },
  computed: {
    ...mapGetters(['setVideoInfos']),
  },
  mounted() {
    this.choices = this.data.choices;
    this.choices.forEach((choice) => {
      choice.selected = false;
    });
  },
  methods: {
    handleClickChoice(i) {
      for (let j = 0; j < this.choices.length; j++) {
        if (j === i) {
          this.choices[j].selected = !this.choices[j].selected;
        } else {
          this.choices[j].selected = false;
        }
      }
    },
    handleSubmit() {
      let indexToSubmit = this.choices.findIndex(
        (element) => element.selected
      );

      if (indexToSubmit !== -1) {
        let objToSend = {
          client: this.setVideoInfos?.client,
          votes: [
            {
              id_inter: this.data.id,
              id_user: cookies.cookiesUserId(),
              responses: [{response:this.choices[indexToSubmit].id + ""}],
              type: this.data.type,
            },
          ],
        };
        RichMediaServices.postRichMediaResponse(objToSend)
          .then(() => {
            let itemSelected = this.choices[indexToSubmit];
            if(itemSelected?.redirect?.type){
            if(itemSelected?.redirect?.type ==="web"){
              this.handleRedirectSondage(itemSelected?.redirect?.link)
            }else if (itemSelected?.redirect?.type ==="timeCode"){
                this.player.currentTime(durationToSeconds(itemSelected?.redirect?.timeCode))
            }
          }
            this.closeModal();
          });
      }
    },
    closeInteractivityModal() {
      this.closeModal();
    },
    handleRedirectSondage(url) {

if (!/^https?:\/\//i.test(url)) {
url = 'http://' + url;
}
window.open(url, "_blank");
},
  },
});
</script>

<style scoped></style>
